// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--rmxJs";
export var Close = "styles-module--Close--KWpRo";
export var Success = "styles-module--Success--yXpjm";
export var ctas = "styles-module--ctas--hBEqR";
export var spacer = "styles-module--spacer--hLlnD";